module.exports = __webpack_public_path__ + "img/m_scdd.4c4e6685.png";